(() => {
  'use strict';

  const BAR_SELECTOR = '[data-jd1-free-shipping]';
  const DRAWER_SELECTOR = '#t4s-mini_cart';
  const DEFAULT_THRESHOLD = 39990000;

  let lastCart = null;
  let refreshTimer = 0;
  let requestController = null;
  let observer = null;

  function config() {
    return window.JD1CartConfig || {};
  }

  function thresholdAmount() {
    const value = Number(config().freeShippingThreshold);
    return Number.isFinite(value) && value > 0 ? value : DEFAULT_THRESHOLD;
  }

  function cartEndpoint() {
    const root = String(window.T4Sroutes?.root_url || '/').replace(/\/$/, '');
    return `${root}/cart.js`;
  }

  function formatMoney(cents, currency) {
    const code = currency || config().currency || 'COP';

    try {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(Number(cents || 0) / 100).replace(/\s/g, '');
    } catch (error) {
      return `$${Math.round(Number(cents || 0) / 100).toLocaleString('es-CO')}`;
    }
  }

  function createBar() {
    const bar = document.createElement('div');
    bar.className = 'jd1-free-shipping-top';
    bar.setAttribute('data-jd1-free-shipping', '');
    bar.setAttribute('role', 'status');
    bar.setAttribute('aria-live', 'polite');
    bar.innerHTML = `
      <div class="jd1-free-shipping-top__text" data-jd1-free-shipping-text></div>
      <div class="jd1-free-shipping-top__track" aria-hidden="true">
        <span data-jd1-free-shipping-progress></span>
      </div>
    `;
    return bar;
  }

  function ensureBar() {
    const drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return null;

    const header = drawer.querySelector(':scope > .t4s-drawer__header') || drawer.querySelector('.t4s-drawer__header');
    if (!header) return null;

    let bar = drawer.querySelector(BAR_SELECTOR);
    if (!bar) bar = createBar();

    if (header.nextElementSibling !== bar) {
      header.insertAdjacentElement('afterend', bar);
    }

    return bar;
  }

  function render(cart) {
    const bar = ensureBar();
    if (!bar || !cart) return;

    const threshold = thresholdAmount();
    const total = Math.max(0, Number(cart.total_price) || 0);
    const remaining = Math.max(0, threshold - total);
    const progress = Math.min(100, Math.max(0, (total / threshold) * 100));
    const currency = cart.currency || config().currency || 'COP';

    let message;
    if (total <= 0) {
      message = `Envío gratis para todos los pedidos sobre ${formatMoney(threshold, currency)}`;
    } else if (remaining > 0) {
      message = `¡Te faltan ${formatMoney(remaining, currency)} para recibir ENVÍO GRATIS!`;
    } else {
      message = '¡Felicidades! Ya tienes ENVÍO GRATIS';
    }

    const text = bar.querySelector('[data-jd1-free-shipping-text]');
    const progressBar = bar.querySelector('[data-jd1-free-shipping-progress]');

    if (text && text.textContent !== message) text.textContent = message;
    if (progressBar) progressBar.style.width = `${progress}%`;
    bar.dataset.completed = remaining === 0 ? 'true' : 'false';
  }

  async function refresh() {
    ensureBar();

    requestController?.abort();
    requestController = new AbortController();

    try {
      const response = await fetch(cartEndpoint(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: requestController.signal
      });

      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);

      lastCart = await response.json();
      render(lastCart);
    } catch (error) {
      if (error.name !== 'AbortError' && lastCart) render(lastCart);
    }
  }

  function scheduleRefresh(delay = 80) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, delay);
  }

  function mutationTouchesCart(mutation) {
    if (mutation.target instanceof Element && mutation.target.closest(BAR_SELECTOR)) return false;
    if (mutation.target instanceof Element && mutation.target.closest(DRAWER_SELECTOR)) return true;

    return Array.from(mutation.addedNodes).some((node) => {
      if (!(node instanceof Element)) return false;
      if (node.matches(BAR_SELECTOR) || node.closest(BAR_SELECTOR)) return false;
      return node.matches(DRAWER_SELECTOR) || Boolean(node.querySelector(DRAWER_SELECTOR));
    });
  }

  function initObserver() {
    if (observer || !document.body) return;

    observer = new MutationObserver((mutations) => {
      if (!mutations.some(mutationTouchesCart)) return;
      ensureBar();
      if (lastCart) render(lastCart);
      scheduleRefresh(120);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    initObserver();
    ensureBar();
    scheduleRefresh(0);
    window.setTimeout(() => scheduleRefresh(0), 350);
    window.setTimeout(() => scheduleRefresh(0), 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  ['cart:updated', 'cart:refresh', 'cart:change', 'shopify:section:load'].forEach((eventName) => {
    document.addEventListener(eventName, () => scheduleRefresh(20));
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-wrapper], [data-drawer-options*="t4s-mini_cart"], [href="#t4s-mini_cart"], [data-action-atc], [data-quantity-selector], [data-cart-remove]')) {
      ensureBar();
      scheduleRefresh(180);
      window.setTimeout(() => scheduleRefresh(0), 650);
    }
  });

  window.addEventListener('pageshow', () => scheduleRefresh(0));
})();
